import { render, staticRenderFns } from "./Herinspecties.vue?vue&type=template&id=0ddddf2d"
import script from "./Herinspecties.vue?vue&type=script&lang=js"
export * from "./Herinspecties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports